import { ChangeDetectionStrategy, Component, Inject, Input, signal } from '@angular/core';
import { SegmentWidth } from '@cbre/components';
import { Elevator } from '@miq/domain/pv';
import { ElevatorToSegmentAdapterService, ElevatorToSegmentAdapterServiceToken } from './property-elevator.adapter';

@Component({
  selector: 'pv-elevator',
  template: `
    <div class="pv-elevator__container" style="height: 100%;">
      <cbre-vertical-segments
        [segmentsData]="elevatorAsSegment()"
        [segmentCount]="elevatorCount"
        [segmentWidth]="segmentWidth"
      ></cbre-vertical-segments>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertyViewElevatorComponent {
  @Input() set elevators(elevators: Elevator[]) {
    this.elevatorAsSegment.set(this.segmentAdapter.adapt(elevators));
  }
  @Input() elevatorCount: number;

  elevatorAsSegment = signal({});
  segmentWidth = SegmentWidth.Dynamic;

  constructor(@Inject(ElevatorToSegmentAdapterServiceToken) private segmentAdapter: ElevatorToSegmentAdapterService) {}
}
